import type { FC, ReactNode } from 'react'

import {
    createContext,
    useContext,
    useMemo,
    useState
} from 'react'

interface HeaderStateValue {
    tucked: boolean
    setTucked: (value: boolean) => void
}

interface HeaderStateProviderProps {
    children: ReactNode
}

const HeaderStateContext = createContext<HeaderStateValue>({
    tucked: false,
    setTucked: () => undefined
})

export const HeaderStateProvider: FC<HeaderStateProviderProps> = ({ children }): ReactNode => {
    const [tucked, setTucked] = useState(false)
    const value = useMemo(() => ({ tucked, setTucked }), [tucked])

    return (
        <HeaderStateContext.Provider value={value}>
            {children}
        </HeaderStateContext.Provider>
    )
}

export const useHeaderState = (): HeaderStateValue => {
    return useContext(HeaderStateContext)
}
